import { HasClassName } from '@monto/react-common-ui'
import { FunctionComponent } from 'react'

export const RoundFilledCheckIcon: FunctionComponent<HasClassName> = ({ className }) => (
  <svg className={className} viewBox="0 96 960 960" xmlns="http://www.w3.org/2000/svg">
    <path d="m424 760 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197 859q-54-54-85.5-127T80 576q0-83 31.5-156T197 293q54-54 127-85.5T480 176q83 0 156 31.5T763 293q54 54 85.5 127T880 576q0 83-31.5 156T763 859q-54 54-127 85.5T480 976Z" fill="currentColor"/>
  </svg>
)
